import type { PlainEnvironment } from "@/queries/environment-queries";
import { useMemo } from "react";
import { getBranch } from "./use-branch";

export function useEnvironmentName(environment?: PlainEnvironment) {
    const name = useMemo(() => {
        if (environment?.metadata?.name) {
            return environment.metadata.name;
        }

        return getBranch(environment);
    }, [environment]);
    return name;
}
